const NUMBER = new Intl.NumberFormat('en-GB');

export function formatAmount(amount: number | null): string {
  return amount === null ? '' : NUMBER.format(amount);
}

const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export function timeAgo(iso: string | null, now: number): string {
  if (!iso) return 'never';

  const elapsed = now - Date.parse(iso);
  if (Number.isNaN(elapsed)) return 'unknown';
  if (elapsed < 2 * MINUTE) return 'just now';
  if (elapsed < HOUR) return `${Math.round(elapsed / MINUTE)} min ago`;
  if (elapsed < DAY) {
    const hours = Math.round(elapsed / HOUR);
    return hours === 1 ? 'an hour ago' : `${hours} hours ago`;
  }

  const days = Math.round(elapsed / DAY);
  if (days === 1) return 'yesterday';
  if (days < 30) return `${days} days ago`;

  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
}
